import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const searchHsnMasters = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/hsn-master/search`, data)
        return await response.data;
    } catch (error) {
        console.log("getHsnMasters - error", error)
        return handleApiError(error)
    }
}

export const getHsnMastersData = async () => {
    try {
        let data = {}
        const response = await axios.get(`${REACT_APP_API_URL}/hsn-master/`, data)
        return await response.data;
    } catch (error) {
        console.log("getHsnMasters - error", error)
        return handleApiError(error)
    }
}

export const getHsnMasterDataById = async (materialHSNId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/hsn-master/${materialHSNId}`)
        return await response.data;
    } catch (error) {
        console.log("getHSNMasterById - error", error)
        return handleApiError(error)
    }
}

export const addHsnMasterData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/hsn-master/create`, data)
        return await response.data;
    } catch (error) {
        console.log("addHSNMaster - error", error)
        return handleApiError(error)
    }
}